import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import '../../../Airoom.css';
import Datatable from "../../../core/common/dataTable/index";
import FilterComponent from "../../../core/common/FilterComponent";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import Ribbon from "../../../core/common/ribbon/ribbon";
import CustomSelect from "../../../core/common/selectPirority/SelectPirority";
import { leadsData } from "../../../core/data/json/leadsData";
import "../../../style/css/index.css";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import FilterModalLeadsInquiry from "./FilterModalLeadsInquiry";
import NoRecordFound from "../../../core/common/noRecord/NoRecordFound";
import TableLoading from "../../../core/common/loadingComponent/TableLoading";
import { useTableSelection } from "../../../core/hooks/useTableSelection";
import { useGetAllLeadInquiryQuery, useGetLeadsProspectsQuery } from "../../../services/EndPointsApis";
import TextField from "../../../core/common/textFields/TextField";
import Pagination from "../../../core/common/pagination/Pagination";
import ManageColumn from "../../../core/common/ManageCoulmnsButton/ManageColumn";
import { initialColumnInquiry } from "./LIModuleColumn";
import TableHeading from "../../../core/common/tableHeading/TableHeading";
import LeadInqsDeleteModal from "./DeleteModalLeadsInquiry/LeadInqDeleteModal";
import LeadInqDeleteModal from "./DeleteModalLeadsInquiry/LeadInqDeleteModal";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { debounce } from "lodash";
import DateComp from "../../../core/common/dateComponent/DateComp";

const LeadInquiry = () => {
  const formattedDate = dayjs().format("YYYY-MM-DD_HH-mm-ss");

  const data = leadsData;
  const [showfilterModal, setShowfilterModal] = useState(false);
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(1)
  const [pageSize, setPageSize] = useState(15);
  const [searchStr, setSearchStr] = useState(''); // debounce search
  const [sortBy, setSortBy] = useState("createDT");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortedColumn, setSortedColumn] = useState("createDT");
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [immediateSearchStr, setImmediateSearchStr] = useState('');

  //get all leads Prospects
  const { data: allLeadsInquiry, refetch, isLoading } = useGetAllLeadInquiryQuery({
    pageNumber: pageNumber,
    pageSize: pageSize,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });

  const { data: allLeadsInquiryCSV } = useGetAllLeadInquiryQuery({
    pageNumber: pageNumber,
    pageSize: 1000,
    searchStr: searchStr || '',
    sortBy: sortBy,
    sortOrder: sortOrder,
  });

  interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
    keys: string;
  }
  const idValue = 'dropdownMenuClickableInsise1';
  const handlefiltermodel = () => {
    setShowfilterModal(true);
    const dropdownToggle = document.getElementById(idValue);
    if (dropdownToggle) {
      dropdownToggle.click();
    }
  }
  const handleSort = (property: string) => {
    setSortBy(property);
    if (sortedColumn === property) {
      setSortOrder(prevSortOrder => (prevSortOrder === "asc" ? "desc" : "asc"));
    } else {
      setSortedColumn(property);
      setSortOrder("asc");
    }
  };
  const {
    isTableHeadChecked,
    selectedIndividualCheckboxId,
    selectedItemData: teamData,
    handleTableHeadChange,
    handleCheckItem,
    handleRowClick,
    handleRowDoubleClick,
    handleDelete
  } = useTableSelection(allLeadsInquiry?.result?.data || [], 'id');

  const isAnyCheckboxChecked = selectedIndividualCheckboxId.length > 0;
  const isMoreThanOneChecked = selectedIndividualCheckboxId.length > 1;


  const getValueByKey = (data: any, key: string) => {
    const value = data[key];
    // Check if the value is an object and has a 'value' property
    if (value && typeof value === 'object' && value.hasOwnProperty('value')) {
      return value.value;
    }
    // If not an object, return the value directly
    return value;
  };



  const handleClose = () => {
    setShowfilterModal(false)
  };
  const handlefilterManage = () => {
  };

  const handleViewDetails = () => {
    navigate(`/leadsInquiry/viewLeadInquiry/${selectedIndividualCheckboxId}`);
  };
  const handleEditLead = () => {
    navigate(`/leadsInquiry/editLeadInquiry/${selectedIndividualCheckboxId}`);
  }
  // const handleAddLead = () => {
  //   navigate('/addLeadInquiry');
  // }
  const navigateContacts = () => {
    navigate('/contacts');
  }
  const navigatenotes = () => {
    navigate('/notes');
  }
  const navigatedocuments = () => {
    navigate('/documents');
  }
  const navigateclientVisits = () => {
    navigate('/clientVisits');
  }
  const navigateTasks = () => {
    navigate('/tasks');

  }

  const handleDoubleClick = (items: any) => {

    handleRowDoubleClick(items);
    // dispatch(setContactsData(items))
    navigate(`/leadsInquiry/viewLeadInquiry/${items?.id}`)
  };
  // Change the state to force re-render
  const handleReload = () => {
    refetch()
  };
  const items = [
    // { label: 'Send to Sales Admin', tooltipLabel: "Send To Sales Admin", icon: svgIcons.SendIcon, },
    // {
    //   label: 'Edit',
    //   tooltipLabel: "Edit",
    //   icon: svgIcons.updateIcon,
    //   onClick: handleEditLead,
    //   disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked,
    //   disableIcon: svgIcons.updateIcon
    // },
    { label: 'View Details', tooltipLabel: "View details", icon: svgIcons.eyeIcon, disableIcon: svgIcons.eyeIcon, onClick: handleViewDetails, disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked },
    {
      tooltipLabel: "Delete", label: "Delete", icon: svgIcons.deleteIcon, disableButton: !isAnyCheckboxChecked || isMoreThanOneChecked, disableIcon: svgIcons.deleteIcon, onClick: () => {
        setShowDeleteModal(true);
      },
    },
    { label: 'Refresh', tooltipLabel: "Refresh", icon: <i className="ti ti-refresh-dot" aria-hidden="true"></i>, onClick: handleReload, }
    // { tooltipLabel: "Export", icon: svgIcons.exportIcon, },
    // { label: "Priority:", icon: svgIcons.PirorityIcon, DropdownButton: <CustomSelect options={dropdownItems} /> },
    // { tooltipLabel: "Contacts", icon: svgIcons.contactsIcon, },
    // { tooltipLabel: "Documents", icon: svgIcons.documentIcon, },
    // { tooltipLabel: "Notes", icon: svgIcons.NotesIcon, },
    // { tooltipLabel: "Client Visits", icon: svgIcons.clientvisits, },
    // { tooltipLabel: "Tasks", icon: svgIcons.TasksIcon, },
  ];


  //search 

  const handleSearchChange = (e: any) => {
    const { value } = e.target;
    setImmediateSearchStr(value);
    delayedSearch(value);
  };
  const delayedSearch = useCallback(
    debounce((searchValue) => {
      setSearchStr(searchValue);
    }, 800),
    []
  );

  useEffect(() => {
    if (searchStr === "" ||
      sortOrder === "" ||
      sortBy === "") {
      refetch()
    }
  }, [searchStr, sortOrder, sortBy]);

  //Pagination 
  const handlePageSizeChange = (selectedOption: any) => {
    setPageSize(selectedOption.value);
    setPageNumber(1); // Reset page number to 1
  };
  const handlePageClick = (e: any) => {
    setPageNumber(e.selected + 1);
  };
  const toCamelCase = (str: string): string => {
    return str
      .toLowerCase()
      .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) =>
        index === 0 ? match.toLowerCase() : match.toUpperCase()
      )
      .replace(/\s+/g, ''); // Remove spaces
  };
  const [visibleColumns, setVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('columnSettingsInquiry');
    return savedColumns
      ? JSON.parse(savedColumns)
      : initialColumnInquiry.reduce((acc, column) => ({ ...acc, [column.id]: column.checked }), {});
  });


  // Handle column visibility toggle
  const handleColumnToggle = (updatedColumns: any) => {
    setVisibleColumns(updatedColumns);
    localStorage.setItem('columnSettingsInquiry', JSON.stringify(updatedColumns)); // Save to localStorage
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false)
  };

  //csv data 
  const headers = initialColumnInquiry.map(item => ({
    label: item.name,
    key: item.keys,
  }));

  const CsvData = allLeadsInquiryCSV?.result?.data?.map((record: Record<string, any>) => {
    const csvRecord: Record<string, any> = {};
    headers?.forEach(header => {
      csvRecord[header.key] = record[header.key]?.value ?? record[header.key] ?? "";
    });
    return csvRecord;
  }) || []

  return (
    <>
      <LeadInqDeleteModal
        show={showDeleteModal}
        handleClose={handleCloseDeleteModal}
        prospectId={selectedIndividualCheckboxId}
        handleDeleteRow={handleDelete}
        // data={UserData}
        refetch={refetch}

      />
      <FilterModalLeadsInquiry show={showfilterModal} handleClose={handleClose} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              <Ribbon
                items={items}
                // buttonText="+ New Lead"
                buttonClass="add-popup ribbon-btn "
                Icon={svgIcons.importIcon}
              // onClickbtn={handleAddLead}
              />
              {/* /Page Header */}
              <div className="card main-card">
                <div className="card-body">
                  {/* Search */}
                  <div className="search-section">
                    <div className="row align-items-center">
                      <div className="col-md-4 col-sm-8">
                        <h4 className="page-title color-red mb-1">All Lead Inquiries</h4>
                      </div>
                      <div className="col-md-8">
                        <div className="d-flex flex-column flex-md-row justify-content-end gap-2 mb-1 ">
                          <CSVLink data={CsvData} headers={headers} filename={`LeadInquiry_List ${formattedDate}.csv`} className="btn btn-light-red d-flex gap-1 align-items-center justify-content-center">
                            <i className="fa fa-file-export" />
                            Export To CSV
                          </CSVLink>
                          <ManageColumn columns={initialColumnInquiry} visibleColumns={visibleColumns} onColumnToggle={handleColumnToggle} />
                          <FilterComponent handlefiltermodel={handlefiltermodel} idValue={idValue} />
                          <>
                            <div className=" icon-form">
                              <span className="form-icon">
                                <i className="ti ti-search" />
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Search Lead"
                                value={immediateSearchStr}
                                onChange={handleSearchChange}
                              />
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive custom-table mt-2 overflow-auto">
                    <table className="table datanew dataTable no-footer table-hover">
                      <thead>
                        <tr>
                          <th>
                            {/* <input
                              type="checkbox"
                              className='form-check-input cursor-pointer'
                              checked={isTableHeadChecked}
                              onChange={handleTableHeadChange}
                            /> */}
                          </th>
                          {/* {activeColumns.map(col =>
                            col.checked && <th key={col.id}>{col.name}</th>
                          )} */}
                          {/* {initialColumnInquiry.map(column => (
                            <th key={column.id}>{column.name || 'No Name'}</th>
                          ))} */}
                          {initialColumnInquiry.map((column) => (
                            visibleColumns[column.id] &&
                            <TableHeading
                              label={column.name}
                              sortedColumn={column.name}
                              columnId={column.name}
                              sortOrder='desc'
                              handleSort={() => handleSort(column?.keys)}
                            />
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {!isLoading &&
                          <>
                            {allLeadsInquiry?.result?.data?.length > 0 ? (
                              <>
                                {allLeadsInquiry?.result?.data?.map((data: any, index: any) => {
                                  return (
                                    <tr key={data.id} onClick={() => handleRowClick(data)} onDoubleClick={() => handleDoubleClick(data)}
                                      className={selectedIndividualCheckboxId.includes(data.id) ? 'selected-row' : ''}>
                                      <td>
                                        <div className="d-flex gap-2">
                                        <TextField
                                          type="checkbox"
                                          fieldClass='form-check-input cursor-pointer'
                                          checked={isTableHeadChecked || selectedIndividualCheckboxId.includes(data.id)}
                                          onChange={(e) => handleCheckItem(e, data)}
                                        />
                                        <Link to={`/leadsInquiry/editLeadInquiry/${data?.id}`}
                                        >
                                          {svgIcons.updateIcon}
                                        </Link>
                                        </div>
                                      </td>
                                      {/* {initialColumnInquiry.map(column => {
                                        const dataKey = column?.keys;
                                        const cellData = getValueByKey(data, dataKey);
                                        return (
                                          <td key={column.id}>
                                            {cellData !== undefined && cellData !== null
                                              ? typeof cellData === 'object' && cellData !== null
                                                ? JSON.stringify(cellData)
                                                : cellData
                                              : 'No data available'}

                                          </td>
                                        );
                                      })} */}
                                      {/* {initialColumnInquiry.map((column) => (
                                        visibleColumns[column.id] && (
                                          <td key={column.id}>
                                            {data[column.keys] !== undefined && data[column.keys] !== null
                                              ? typeof data[column.keys] === 'object'
                                                ? JSON.stringify(data[column.keys])
                                                : data[column.keys]
                                              : 'No data available'}
                                          </td>
                                        )
                                      ))} */}
                                      {initialColumnInquiry.map((column) => (
                                        visibleColumns[column.id] && (
                                          <td key={column.id}>
                                            {
                                              column.keys === 'lst_Status' ? (
                                                data[column.keys]?.value === "Active" ? (
                                                  <span className="">Active</span>
                                                ) : data[column.keys]?.value === "InActive" ? (
                                                  <span className="">Inactive</span>
                                                ) : (
                                                  <span className="">None</span>
                                                )
                                              ) : column.keys === 'recordNumber' ? (
                                                <Link to={`/leadsProspect/editLead/${data?.leadProspectId}`}>
                                                  <span className=" ">  {data?.recordNumber || ''}</span>
                                                </Link>
                                              ) : column.keys === 'leadInquiryRecNumber' ? (
                                                <Link to={`/leadsInquiry/editLeadInquiry/${data?.id}`}>
                                                  <span className=" ">  {data?.leadInquiryRecNumber || ''}</span>
                                                </Link>
                                              ) : column.keys === 'createdOn' ? (
                                                <DateComp formattedDate={data?.createdOn || ''} />
                                              ) : column.keys === 'estimatedCloseDate' ? (
                                                <DateComp formattedDate={data?.estimatedCloseDate || ''} />
                                              ) : column.keys === 'inquiryDate' ? (
                                                <DateComp formattedDate={data?.inquiryDate || ''} />
                                              ) : column.keys === 'freshAppointmentDate' ? (
                                                <DateComp formattedDate={data?.freshAppointmentDate || ''} />
                                              ) : column.keys === 'proposalAppointmentDate' ? (
                                                <DateComp formattedDate={data?.proposalAppointmentDate || ''} />
                                              ) : column.keys === 'modifiedOn' ? (
                                                <DateComp formattedDate={data?.modifiedOn || ''} />
                                              ) : column.keys === 'lst_Contact' ? (
                                                <Link to={`/contacts/EditContacts/${data?.lst_Contact?.id}`}>
                                                  <span className=" ">  {data?.lst_Contact?.value || ''}</span>
                                                </Link>
                                              ) :
                                                (
                                                  data[column.keys] !== undefined && data[column.keys] !== null ? (
                                                    typeof data[column.keys] === 'object' && data[column.keys] !== null ? (
                                                      data[column.keys].value !== undefined ? (
                                                        data[column.keys].value
                                                      ) : (
                                                        ''
                                                      )
                                                    ) : (
                                                      data[column.keys]
                                                    )
                                                  ) : (
                                                    ''
                                                  )
                                                )}
                                          </td>
                                        )
                                      ))}
                                    </tr>
                                  )
                                })}
                              </>
                            ) :
                              (<tr>
                                <td colSpan={12}>
                                  <NoRecordFound />
                                </td>
                              </tr>)}
                          </>
                        }
                        {isLoading &&
                          <TableLoading />
                        }
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    // totalResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : ((allUsers?.result?.value?.result?.pageNumber - 1) * allUsers?.result?.value?.result?.pageSize) + 1}
                    // toResult={allUsers?.result?.value?.result?.totalRecords === 0 ? 0 : Math.min(allUsers?.result?.value?.result?.pageNumber * allUsers?.result?.value?.result?.pageSize, allUsers?.result?.value?.result?.totalRecords)}
                    // ofResult={allUsers?.result?.value?.result?.totalRecords}
                    onChange={handlePageSizeChange}
                    pageSize={pageSize}
                    onPageChange={handlePageClick}
                    pageCount={allLeadsInquiry?.result?.totalPages || 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadInquiry;



